import { takeLatest } from 'redux-saga/effects';
import { createChapterWorker, fetchPagesOfChapterWorker } from './chapterWorkerSaga';
import { CREATE_CHAPTER_REQUEST, FETCH_CHAPTER_LIST_REQUEST } from '../../redux/modules/chapter/chapter-actions';


export function* fetchPagesOfChapterWatcher() {
    yield takeLatest(FETCH_CHAPTER_LIST_REQUEST, fetchPagesOfChapterWorker);
}

export function* createChapterWatcher() {
    yield takeLatest(CREATE_CHAPTER_REQUEST, createChapterWorker);
}
